'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Xr = exports.Xt = exports.Xsi = exports.Xsst = undefined;

var _dec, _class, _dec2, _class2;

var _node = require('./node');

let Xsst = exports.Xsst = (_dec = (0, _node.props)('xmlns', 'count', 'uniqueCount'), _dec(_class = class Xsst extends _node.Node {
  constructor(_ref, children) {
    var _ref$xmlns = _ref.xmlns;
    let xmlns = _ref$xmlns === undefined ? 'http://schemas.openxmlformats.org/spreadsheetml/2006/main' : _ref$xmlns;

    super({ xmlns: xmlns }, children);
    this[_node.HEAD] = '<?xml version="1.0" encoding="UTF-8"?>';
  }
}) || _class);
let Xsi = exports.Xsi = class Xsi extends _node.Node {};
let Xt = exports.Xt = (_dec2 = (0, _node.props)('xml:space'), _dec2(_class2 = class Xt extends _node.Node {}) || _class2);
let Xr = exports.Xr = class Xr extends _node.Node {};